import { Component, OnInit, Input } from '@angular/core';
import { BcAccountClientService } from '../../service/bc-account-client.service';
import { FlashMessagesService } from 'angular2-flash-messages';

@Component({
  selector: 'app-bc-ap-committee',
  templateUrl: './bc-ap-committee.component.html',
  styleUrls: ['./bc-ap-committee.component.scss']
})
export class BcApCommitteeComponent implements OnInit {

  constructor(private bcAccountClientService: BcAccountClientService,
              private flashMessagesService: FlashMessagesService) { }

  @Input("proposalID") proposalID;

  private comitteeData;
  private userID;
  private conceptH = false;
  private comentario;

  ngOnInit() {
    this.getAllowanceCommittee();
    this.userID = localStorage.getItem('yara.userID');
  }

  getAllowanceCommittee(){
      this.bcAccountClientService.getAllowanceCommittee(this.proposalID).subscribe(result => {
        if (result.Success) {
          this.comitteeData = result.Result;
          console.log(this.comitteeData);
        } else {
          this.flashMessagesService.show(result.Errors, { cssClass: 'alert-success', timeout: 6000 });
        }
      }, error => {
        console.log(error);
      });
    }

  onSave(approve, index){

    const objToSend = {
        FluxoID: this.comitteeData[index].ID,
        ConceitoH: this.conceptH,
        Aprovado: approve,
        Comentario: this.comentario,
        PropostaAbonoID: this.proposalID
        }

    this.bcAccountClientService.saveAllowanceApproval(objToSend).subscribe(result => {
      if (result.Success) {
        this.getAllowanceCommittee();
        if (this.comitteeData[this.comitteeData.length - 1].Nivel == this.comitteeData[index].Nivel){
          this.bcAccountClientService.proposalChanged.next();
          this.bcAccountClientService.billingChaged.next();
          this.flashMessagesService.show("Proposta alterada com sucesso!", { cssClass: 'alert-success', timeout: 6000 });
        } 
        this.flashMessagesService.show("Fluxo de comitê salvo com sucesso!", { cssClass: 'alert-success', timeout: 6000 });      
        this.comentario = null;
        this.conceptH = false;        
      } else {
        this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
      }
    }, error => {
      console.log(error);
    });

    
  }
}



// WEBPACK FOOTER //
// ./src/app/billing-control/bc-account-client/bc-allowance-proposal/bc-ap-committee/bc-ap-committee.component.ts